import React from 'react';
import { Redirect } from "react-router-dom";
import { APPID, APPVERSION } from '../common/globals';
import { BASE_AXIOS } from "../config";

export const apiGetFlashCards = async (data) => {
    let form = new FormData();
    let obj = {
        mcid: data.mcid,
        key: data.key
    }
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getFlashCards"
            },
            data: form
        });
        
        let post;
        if (typeof response.data.decks !== 'undefined') {
            post = response.data.decks;
        } else { post = []; }

        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetThisFlashCard = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    
    if (typeof data.year !== 'undefined' && data.year > 0) {
        form.append("year", data.year);
    }

    if (typeof data.deckid !== 'undefined') {
        form.append("deckid", data.deckid);
    } else if (typeof data.deckID !== 'undefined') {
        form.append("deckid", data.deckID);
    } else if (typeof data.deckId !== 'undefined') {
        form.append("deckid", data.deckId);
    }

    if (typeof data.questionid !== 'undefined') {
        form.append("questionid", data.questionid);
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getThisFlashCard"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetDecks = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getDecks"
            },
            data: form
        });
        
        let temp;
        if (typeof response.data[0].decks !== 'undefined') {
            temp = response.data[0].decks;
        } else { temp = []; }

        return temp;
    } catch (error) {
        throw error;
    }
};

export const apiRemoveShare = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("fkdeckid", data.fkdeckid);
    form.append("owner", data.owner ? 1 : 0);
    form.append("active",0);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "removeShareDeck"
            },
            data: form
        });
        
        let temp;
        if (typeof response.data[0].decks !== 'undefined') {
            temp = response.data[0].decks;
        } else { temp = []; }

        return temp;
    } catch (error) {
        throw error;
    }
}

export const apiGetPublicDecks = async (data) => {
    let form = new FormData();
    let obj = {
        mcid: data.mcid,
        key: data.key
    }
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getPublicDecks"
            },
            data: form
        });
        
        let results;
        if (typeof response.data[0].decks !== 'undefined') {
            if (!Array.isArray(response.data[0].decks)) {
                results = [];
            } else {
                results = response.data[0].decks;
            }
        } else { results = []; }
        return results;
    } catch (error) {
        throw error;
    }
}

export const apiGetPremadeDecks = async (data) => {
    let form = new FormData();
    let obj = {
        mcid: data.mcid,
        key: data.key
    }
    form.append("mcid", data.mcid);
    form.append("key", data.key);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getPremadeDecks"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetQuizzes = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("programid", data.programid);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getQuizzes"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    } 
}

export const apiGetLongQuizzes = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("programid", data.programid);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getLongQuizzes"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetProgramQuizzes = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("programid", data.programid);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get decks');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getProgramQuizzes"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiSyncCMETest = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("year", data.year);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);
    form.append("gamemode", data.gamemode ? Number(data.gamemode) : 1);
    form.append("deckid", 0);

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get tests');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getSyncedTestYear"
            },
            data: form,
            onDownloadProgress: (progressEvent) => {
                const total = progressEvent.total || progressEvent.loaded;
                const percentComplete = Math.round((progressEvent.loaded * 100) / total);

            },
            onUploadProgress: (progressEvent) => {
                const total = progressEvent.total || progressEvent.loaded;
                const percentComplete = Math.round((progressEvent.loaded * 100) / total);

            }
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetStoredYears = async (data) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("year", data.year);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);
    form.append("gamemode", data.gamemode ? Number(data.gamemode) : 1);
    form.append("deckid", 0);

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", 'get tests');
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getStoredYears"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const apiGetQuiz = async (data, tracking) => {
    let form = new FormData();

    form.append("mcid", data.mcid);
    form.append("programid", data.programid);
    form.append("availableyears", data.availableyears ? data.availableyears : '2012,2013');
    form.append("key", data.key);
    form.append('deckid', data.deckid);
    form.append('gamemode', data.gamemode);
    // form.append('year', data.year)

    if (typeof data.year !== 'undefined') {
        form.append('year', data.year);
    }

    if (typeof data.isquiz !== 'undefined') {
        form.append('isquiz', data.isquiz);
    }

    if (typeof data.sortorder !== 'undefined' && data.sortorder) {
        form.append('sortorder', 1)
    }

    if (typeof tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", tracking.pathname);
        form.append("pagevia", tracking.pagevia);
        form.append("action", 'get quiz');
        form.append("os", tracking.os);
        form.append("ua", tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getQuiz"
            },
            data: form
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
}